import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import '@/assets/scss/index.scss'
import baiduAnalytics from 'vue-baidu-analytics';

if (!Promise.try) {
  Promise.try = function (fn) {
      return new Promise((resolve, reject) => {
          try {
              const result = fn();
              if (result instanceof Promise) {
                  result.then(resolve).catch(reject);
              } else {
                  resolve(result);
              }
          } catch (error) {
              reject(error);
          }
      });
  };
}

Vue.config.productionTip = false

Vue.use(ElementUI)

// 配置百度统计插件
// Vue.use(baiduAnalytics, {
//   router: router,
//   siteIdList: ['4fde98a7cfafd9dfe0ad382a709b8a88'], // 确保这里填写了正确的百度统计站点 ID
//   isDebug: true // 开发环境可以设置为 true，上线前记得关闭
// });

// Vue.use(baiduAnalytics, {
//   router: router,
//   siteIdList: ['b8f67b7ad05c3f334326638845611d9a'],
//   isDebug: false,
// });

const app = new Vue({
  router,
  store,
  render: function (h) { return h(App) }
})


// app.use(BaiduAnalytics, { id: 'b8f67b7ad05c3f334326638845611d9a' }); // 使用插件并传递百度统计代码ID
app
 .$mount('#app')
